import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HlmToasterComponent } from '@helipagos-ng/ui-sonner-helm';
import { PosthogService } from '@hp-core/analytics/posthog.service';

@Component({
  standalone: true,
  imports: [RouterModule, HlmToasterComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'admins';

  // PosthogService se inyecta para forzar su inicialización antes de renderizar.
  constructor(private titleService: Title, _posthog: PosthogService) {
    this.titleService.setTitle('Administración Helipagos');
  }
}
